export enum DonationType {
  Credit = 'credit',
  Debit = 'debit',
  PayPal = 'paypal',
  Check = 'echeck',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay'
}

export class Donation {
  public amount = 0;
  public type: DonationType = DonationType.Credit;
  public double = '';
  public enabledTypes: {text: string, value: DonationType}[] = [];
}
